// src/pages/HomePage.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import GradientButton from '../components/GradientButton';

const HomePage = () => {
  const navigate = useNavigate();

// Vibe Pixel for Homepage
  useEffect(() => {
    /* eslint-disable no-unused-expressions, no-sequences, new-parens */
    !function(v,i,b,e,c,o){if(!v[c]){var s=v[c]=function(){s.process?s.process.apply(s,arguments):s.queue.push(arguments)};s.queue=[],s.b=1*new Date;var t=i.createElement(b);t.async=!0,t.src=e;var n=i.getElementsByTagName(b)[0];n.parentNode.insertBefore(t,n)}}(window,document,"script","https://s.vibe.co/vbpx.js","vbpx");
    /* eslint-enable no-unused-expressions, no-sequences, new-parens */
    window.vbpx('init','5E1q8x');
    window.vbpx('event', 'page_view');
  }, []);

  // Google Analytics
  useEffect(() => {
    // Load gtag script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-X0CG0XBMDR';
    document.head.appendChild(script);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag(){window.dataLayer.push(arguments);}
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', 'G-X0CG0XBMDR');
  }, []);

  return (
    <div style={{ 
      fontFamily: "'Open Sans', sans-serif",
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column'
    }}>
      {/* Hero Section */}
<div
  style={{
    background: 'linear-gradient(135deg, #A6CE3A 0%, #8BB62A 100%)',
    borderRadius: '16px',
    padding: '2rem 1rem',
marginTop: '1rem',
    textAlign: 'center',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '40vh',
    margin: '1rem',
    boxShadow: '0 8px 32px rgba(166, 206, 58, 0.3)'
  }}
>
        <h1
          style={{
            margin: '0 0 1rem 0',
            color: '#FFF',
            fontWeight: 'bold',
            fontSize: 'clamp(1.75rem, 8vw, 3rem)',
            textShadow: '2px 2px rgba(0,0,0,0.2)',
            lineHeight: '1.2',
            maxWidth: '100%'
          }}
        >
          Smarter Lottery Picks.
          <br />
          Powered by AI.
        </h1>
        
        <p style={{
          color: '#FFF',
          fontSize: 'clamp(1rem, 4vw, 1.25rem)',
          margin: '0 0 2rem 0',
          opacity: 0.95,
          maxWidth: '600px',
          lineHeight: '1.4'
        }}>
          Get your personal Powerball and Mega Millions numbers for about a $1 per month.
        </p>

        <GradientButton
          variant="blue"
          onClick={() => navigate('/signup')}
          style={{ maxWidth: '90%' }}
        >
          Sign Up Now
        </GradientButton>
      </div>

{/* Content Section - Ready for Video */}
      <div style={{ 
        padding: '2rem 1rem',
        backgroundColor: '#f8fafc',
        textAlign: 'center',
        minHeight: '40vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        {/* Video with auto-play + replay overlay */}
        <div
          style={{
            width: '100%',
            maxWidth: '800px',
            marginBottom: '1rem',
            position: 'relative',
            borderRadius: '12px',
            overflow: 'hidden',
          }}
        >
          {/* The video element */}
          <video
            id="ll-home-video"
            ref={el => {
              window.__llVideo = el;
              // Auto-play muted after 2 seconds
              if (el && !window.__llVideoAutoPlayTriggered) {
                window.__llVideoAutoPlayTriggered = true;
                setTimeout(() => {
                  const cover = document.getElementById('ll-video-cover');
                  if (cover) cover.style.display = 'none';
                  el.muted = true;
                  el.play().catch(() => {
                    // If autoplay blocked, show cover again
                    if (cover) cover.style.display = 'flex';
                  });
                }, 2000);
              }
            }}
            style={{
              width: '100%',
              height: 'auto',
              display: 'block',
              backgroundColor: '#000',
            }}
            src="/videos/LottoLogic_Homepage.mp4"
            type="video/mp4"
            controls
            playsInline
            onEnded={() => {
              // Reset and show the cover again
              if (window.__llVideo) {
                window.__llVideo.pause();
                window.__llVideo.currentTime = 0;
                window.__llVideo.muted = false; // Enable sound for replay
              }
              const cover = document.getElementById('ll-video-cover');
              if (cover) cover.style.display = 'flex';
            }}
          />

          {/* Clickable cover overlay */}
          <div
            id="ll-video-cover"
            role="button"
            tabIndex={0}
            aria-label="Play video: Click to learn about LuckyLogic.ai"
            onClick={() => {
              const v = window.__llVideo;
              if (v) {
                v.muted = false; // Play with sound on manual click
                v.play();
                const cover = document.getElementById('ll-video-cover');
                if (cover) cover.style.display = 'none';
              }
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                const v = window.__llVideo;
                if (v) {
                  v.muted = false;
                  v.play();
                  const cover = document.getElementById('ll-video-cover');
                  if (cover) cover.style.display = 'none';
                }
              }
            }}
            style={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '1rem',
              cursor: 'pointer',
              backgroundImage: 'linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url("/images/ll-video-cover.jpg")',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          >
            {/* Scrim + text + play button */}
            <div
              style={{
                background: 'rgba(0,0,0,0.45)',
                color: 'white',
                borderRadius: '12px',
                padding: '1rem 1.25rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem',
              }}
            >
              <div
                aria-hidden="true"
                style={{
                  width: '56px',
                  height: '56px',
                  borderRadius: '9999px',
                  background: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 6px 18px rgba(0,0,0,0.35)',
                  fontSize: '1.5rem',
                  color: '#10b981',
                }}
              >
                ▶
              </div>
              <div style={{ fontWeight: 700, fontSize: '1.05rem' }}>
                Click to learn about LuckyLogic.ai
              </div>
            </div>
          </div>
        </div>

{/* Choose Your Plan Section */}
<div
  style={{
    width: '100%',
    maxWidth: '900px',
    marginTop: '2rem',
    marginBottom: '1rem',
    backgroundColor: 'white',
    borderRadius: '16px',
    padding: '2rem 1.5rem',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
  }}
>
  {/* Header */}
  <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
      <span style={{ fontSize: '1.75rem' }}>💰</span>
      <h2 style={{ margin: 0, fontSize: 'clamp(1.5rem, 5vw, 2rem)', fontWeight: '700', color: '#1f2937' }}>
        Choose Your Plan
      </h2>
    </div>
    <p style={{ margin: 0, color: '#6b7280', fontSize: 'clamp(0.95rem, 3vw, 1.1rem)' }}>
      2 simple plans. One for everyday lottery players. One for players who buy tickets for massive jackpots.
    </p>
  </div>

  {/* Plan Cards */}
  <div style={{
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(min(280px, 100%), 1fr))',
    gap: '1.5rem',
  }}>
    {/* Jackpot Chaser - MOST POPULAR */}
    <div style={{
      border: '2px solid #A6CE3A',
      borderRadius: '16px',
      padding: '1.5rem',
      backgroundColor: 'white',
      position: 'relative',
      boxShadow: '0 8px 24px rgba(166, 206, 58, 0.18)',
    }}>
      <div style={{
        position: 'absolute',
        top: '8px',
        right: '8px',
        backgroundColor: '#A6CE3A',
        color: 'white',
        padding: '0.25rem 0.5rem',
        borderRadius: '999px',
        fontSize: '0.65rem',
        fontWeight: 700,
        whiteSpace: 'nowrap',
      }}>
        MOST POPULAR
      </div>
      <div style={{ marginBottom: '1rem' }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '0.5rem' }}>
          <span style={{ fontSize: 'clamp(2rem, 7vw, 2.5rem)', fontWeight: '800', color: '#1f2937' }}>$14.99</span>
          <span style={{ fontSize: '1rem', color: '#6b7280' }}>per year</span>
        </div>
        <p style={{ margin: '0.5rem 0 0 0', fontWeight: '700', color: '#1f2937', fontSize: '1.1rem' }}>
          🎯 Jackpot Chaser
        </p>
      </div>
      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {[
          'Numbers when jackpots hit your threshold',
          'Choose $500M+, $750M+, or $1B+',
          'Powerball & Mega Millions',
          'Text & email delivery',
          'Annual subscription (no cancellations)'
        ].map((item, i) => (
          <li key={i} style={{ display: 'flex', alignItems: 'center', marginBottom: '0.6rem', color: '#4b5563', fontSize: '0.95rem' }}>
            <span style={{ color: '#10b981', marginRight: '0.5rem', fontSize: '1.1rem' }}>✓</span>{item}
          </li>
        ))}
      </ul>
      <p style={{ marginTop: '1rem', fontWeight: '700', color: '#16a34a', fontSize: '0.95rem' }}>
        👉 Perfect for players who only play 500M+ Jackpots
      </p>
    </div>

    {/* Weekly Player - BEST VALUE */}
<div style={{
      border: '2px solid #1E9FF2',
      borderRadius: '16px',
      padding: '1.5rem',
      backgroundColor: '#f9fafb',
      position: 'relative',
    }}>
      <div style={{
        position: 'absolute',
        top: '8px',
        right: '8px',
        backgroundColor: '#1E9FF2',
        color: 'white',
        padding: '0.25rem 0.5rem',
        borderRadius: '999px',
        fontSize: '0.65rem',
        fontWeight: 700,
        whiteSpace: 'nowrap',
      }}>
        BEST VALUE
      </div>
      <div style={{ marginBottom: '1rem' }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '0.5rem' }}>
          <span style={{ fontSize: 'clamp(2rem, 7vw, 2.5rem)', fontWeight: '800', color: '#1f2937' }}>$34.99</span>
          <span style={{ fontSize: '1rem', color: '#6b7280' }}>per year</span>
        </div>
        <p style={{ margin: '0.5rem 0 0 0', fontWeight: '700', color: '#1f2937', fontSize: '1.1rem' }}>
          🎲 Weekly Player
        </p>
      </div>
      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {[
          'Numbers for every drawing',
          'Or set your own threshold (All, 100M+, etc.)',
          'Powerball & Mega Millions',
          'Text & email delivery',
          'Annual subscription (no cancellations)'
        ].map((item, i) => (
          <li key={i} style={{ display: 'flex', alignItems: 'center', marginBottom: '0.6rem', color: '#4b5563', fontSize: '0.95rem' }}>
            <span style={{ color: '#10b981', marginRight: '0.5rem', fontSize: '1.1rem' }}>✓</span>{item}
          </li>
        ))}
      </ul>
      <p style={{ marginTop: '1rem', fontWeight: '700', color: '#16a34a', fontSize: '0.95rem' }}>
        👉 Perfect for players who play every week
      </p>
    </div>
  </div>
</div>

        {/* Call to Action */}
        <div style={{
          marginTop: '1rem',
marginBottom: '1rem',
          padding: '2rem',
          backgroundColor: 'white',
          borderRadius: '16px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
          maxWidth: '600px',
          width: '100%'
        }}>
          <h2 style={{
            margin: '0 0 1rem 0',
            fontSize: 'clamp(1.5rem, 5vw, 2rem)',
            fontWeight: '700',
            color: '#1f2937',
            lineHeight: '1.2'
          }}>
            Ready to Get Better
            <br />
            Lottery Numbers using AI?
          </h2>
          <GradientButton
            variant="blue"
            onClick={() => navigate('/signup')}
            style={{ maxWidth: '90%' }}
          >
            Sign Up Now
          </GradientButton>
        </div>
      </div>

{/* Disclaimer */}
        <div style={{
          fontSize: '0.65rem',
          color: '#666',
          backgroundColor: '#f9f9f9',
          padding: '1rem',
          border: '1px solid #ccc',
          borderRadius: '16px',
          marginTop: '1rem',
          marginBottom: '.5rem',
          maxWidth: '600px',
          width: '100%',
          lineHeight: '1.2',
          margin: '1rem auto 2rem auto'
        }}>
          LuckyLogic.ai is not affiliated with, endorsed by, or sponsored by Powerball®, the Multi-State Lottery Association (MUSL), Mega Millions®, or the Mega Millions Consortium. All trademarks, service marks, and logos appearing herein are the property of their respective owners. The use of these marks is solely for the purpose of accurately identifying the lottery games supported by our service and does not imply any association or partnership.
        </div>
    </div>
  );
};

export default HomePage;